import {ApplicationSetting} from "../../entities/ApplicationSetting";
import {NotificationService} from "../../services/NotificationService";
import {ApplicationSettingService} from "../../services/ApplicationSettingService";

export class DisplayOptionsModel {
        static $inject = ['$q','ApplicationSettingService','NotificationService'];
        applicationSetting:ApplicationSetting;
        selectedAssetAvailable:string;
        selectedAssetAssigned:string;
        selectedVTagAvailable:string;
        selectedVTagAssigned:string;
        availableAssets:string[] = [];
        assignedAssets:string[] = [];
        availableVTags:string[] = [];
        assignedVTags:string[] = [];
        assetColumns = ["name", "description", "rfidTag", "batteryLevel", "vTagID", "vTagGpsDeviceID", "locationName", "locationSite", "locationBuilding", "locationFloor", "locationRoom", "locationDescription",
           "assetType", "departmentCode", "checkinStatus", "lastObservedLocation",
          "lastObservedTime", "additionalInformation", "disposalStatus", "disposalMethod", "disposalDate", "nextMaintenance", "lastMaintenance", "listValue1", "listValue2", "listValue3", "listValue4",
          "listValue5", "date1", "date2", "date3", "date4", "date5", "text1", "text2", "text3", "text4", "text5", "text6", "text7", "text8", "text9", "text10", "text11", "text12",
          "text13", "text14", "text15", "text16", "text17", "text18", "text19", "text20", "vTagX", "vTagY", "vTagZ", "vTagPositionType", "vTagLastSeen", "vTagLastMoved",
          "nearestFixed", "nearestFixedName", "created", "lastModified", "lastModifiedBy", "latitude", "longitude", "numberOfSatellites", "lastGPSFix", "vTagType", "gpsAccuracy",
          "missedSatelliteFixes", "parentVTag", "lastInventoried"];
        // Following defaults are quickly overridden by the database settings, so no point in changing....
        defaultAssetColumns = ["name", "description", "rfidTag", "vTagID", "locationName", "created", "lastModified"];
        defaultVtagColumns = ["name", "description", "vTagID", "batteryLevel", "vTagLastSeen"];
        errorMessage:string = "";
        constructor(public $q:ng.IQService,
                    public applicationSettingService:ApplicationSettingService,
                    public notifyService:NotificationService) {
            this.applicationSettingService.getCached()
                .then((data)=>{
                    this.applicationSetting = data;
                    this.availableAssets = this.assetColumns.slice(0);
                    this.assignedAssets = this.applicationSetting.assetDisplayColumns.split(",");
                    this.setupAssignedAvailable(this.assignedAssets, this.defaultAssetColumns, this.availableAssets, this.assignedAssets);
                    this.availableVTags = this.assetColumns.slice(0);
                    this.assignedVTags = this.applicationSetting.vTagPopupDisplayRows.split(",");
                    this.setupAssignedAvailable(this.assignedVTags, this.defaultVtagColumns, this.availableVTags, this.assignedVTags);
                    if(this.availableAssets.length > 0)
                        this.selectedAssetAvailable = this.availableAssets[0];
                    if(this.assignedAssets.length > 0)
                        this.selectedAssetAssigned = this.assignedAssets[0];
                    if(this.availableVTags.length > 0)
                        this.selectedVTagAvailable = this.availableVTags[0];
                    if(this.assignedVTags.length > 0)
                        this.selectedVTagAssigned = this.assignedVTags[0];
                })
                .catch((exc)=>{
                    this.notifyService.notify("Got error:"+exc);
                });
        }
        setupAssignedAvailable(dbAssigned:string[], defaultAssigned:string[], availableArray:string[],assignedArray:string[]):void{
            if(dbAssigned.length == 0)
                assignedArray = defaultAssigned.slice(0);
            else
                assignedArray = dbAssigned.slice(0);
            for(var i=0;i<assignedArray.length;i++){
                var indexOf = availableArray.indexOf(assignedArray[i]);
                if(indexOf != -1)
                    availableArray.splice(indexOf,1);
            }
        }
        MoveAssetDown() {
            var sel = this.selectedAssetAssigned;
            if (sel == null)
                return;
            var selectedIndex = this.assignedAssets.indexOf(sel);
            if (selectedIndex >= this.assignedAssets.length -1)
                return;

            var indexToSwap = selectedIndex + 1;
            var itemToSwap = this.assignedAssets[indexToSwap];

            this.assignedAssets[indexToSwap] = sel;
            this.assignedAssets[selectedIndex] = itemToSwap;
        }
        MoveAssetUp() {
            var sel = this.selectedAssetAssigned;
            if (sel == null)
                return;
            var selectedIndex = this.assignedAssets.indexOf(sel);
            if (selectedIndex < 1)
                return;

            var indexToSwap = selectedIndex - 1;
            var itemToSwap = this.assignedAssets[indexToSwap];

            this.assignedAssets[indexToSwap] = sel;
            this.assignedAssets[selectedIndex] = itemToSwap;
        }
        AddAsset() {
            var sel = this.selectedAssetAvailable;
            if (sel == null)
                return;
            var selIndex = this.availableAssets.indexOf(sel);
            var atEnd = selIndex >= this.availableAssets.length - 1;
            this.assignedAssets.push(sel);
            this.availableAssets.splice(selIndex, 1);
            if (!atEnd) {
                this.selectedAssetAvailable = this.availableAssets[selIndex];
            }
            else {
                this.selectedAssetAvailable = this.availableAssets[selIndex - 1];
            }
        }
        RemoveAsset() {
            var sel = this.selectedAssetAssigned;
            if (sel == null)
                return;
            var selIndex = this.assignedAssets.indexOf(sel);
            var atEnd = selIndex >= this.assignedAssets.length - 1;
            this.availableAssets.push(sel);
            this.assignedAssets.splice(selIndex, 1);
            if (!atEnd) {
                this.selectedAssetAssigned = this.assignedAssets[selIndex];
            }
            else {
                this.selectedAssetAssigned = this.assignedAssets[selIndex - 1];
            }
        }
        MoveVTagDown() {
            var sel = this.selectedVTagAssigned;
            if (sel == null)
                return;
            var selectedIndex = this.assignedVTags.indexOf(sel);
            if (selectedIndex >= this.assignedVTags.length - 1)
                return;

            var indexToSwap = selectedIndex + 1;
            var itemToSwap = this.assignedVTags[indexToSwap];

            this.assignedVTags[indexToSwap] = sel;
            this.assignedVTags[selectedIndex] = itemToSwap;
        }
        MoveVTagUp () {
            var sel = this.selectedVTagAssigned;
            if (sel == null)
                return;
            var selectedIndex = this.assignedVTags.indexOf(sel);
            if (selectedIndex < 1)
                return;

            var indexToSwap = selectedIndex - 1;
            var itemToSwap = this.assignedVTags[indexToSwap];

            this.assignedVTags[indexToSwap] = sel;
            this.assignedVTags[selectedIndex] = itemToSwap;
        }
        AddVTag () {
            var sel = this.selectedVTagAvailable;
            if (sel == null)
                return;
            var selIndex = this.availableVTags.indexOf(sel);
            var atEnd = selIndex >= this.availableVTags.length - 1;
            this.assignedVTags.push(sel);
            this.availableVTags.splice(selIndex, 1);
            if (!atEnd) {
                this.selectedVTagAvailable = this.availableVTags[selIndex];
            }
            else {
                this.selectedVTagAvailable = this.availableVTags[selIndex - 1];
            }
        }
        RemoveVTag() {
            var sel = this.selectedVTagAssigned;
            if (sel == null)
                return;
            var selIndex = this.assignedVTags.indexOf(sel);
            var atEnd = selIndex >= this.assignedVTags.length - 1;
            this.availableVTags.push(sel);
            this.assignedVTags.splice(selIndex, 1);
            if (!atEnd) {
                this.selectedVTagAssigned = this.assignedVTags[selIndex];
            }
            else {
                this.selectedVTagAssigned = this.assignedVTags[selIndex - 1];
            }
        }

        Save(){
            var assetColumns = this.assignedAssets.join();
            var vTagColumns = this.assignedVTags.join();
            this.applicationSetting.assetDisplayColumns = assetColumns;
            this.applicationSetting.vTagPopupDisplayRows = vTagColumns;
            this.applicationSettingService.update(this.applicationSetting).then(()=>{
                this.notifyService.notify("Display Options Updated Successfully!")
            })
            .catch((exc)=>{
                    this.notifyService.notify("Update Exception:"+exc);
            });
        }
    }
